<tui-flat-picker
    class="t-flat"
    [style.backgroundColor]="base"
    [value]="point"
    (valueChange)="onPointChange($event)"
></tui-flat-picker>
<div class="t-wrapper t-wrapper_hue">
    <tui-linear-picker
        class="t-hue"
        [value]="hue"
        (valueChange)="onHueChange($event)"
    ></tui-linear-picker>
</div>
<div
    class="t-wrapper t-wrapper_opacity"
    [style.background]="gradient"
>
    <tui-linear-picker
        class="t-opacity"
        [value]="opacity"
        (valueChange)="onOpacityChange($event)"
    ></tui-linear-picker>
</div>
